// @module Dev.Brochures.BrochuresModule
define('Dev.ShoppingActions.ShoppingActionsModule.Router'
,	[
		'Dev.ShoppingActions.ShoppingActionsModule.View'
	,	'Dev.ShoppingActions.ShoppingActionsModule.Model'
	,	'Backbone'
	,	'jQuery'
    ]
, function (
		ShoppingActionsModuleView
	,	ShoppingActionsModuleModel
	,	Backbone
	,	jQuery
)
{
    'use strict';

	return Backbone.Router.extend({

		//@property {Object} routes
		routes: {
			'weight-calculator': 'showGlassWeightCalculator'  
		}

		//@method initialize
		//@param {ApplicationSkeleton} application
		//@return {Void}
	,	initialize: function (application)
		{
			this.application = application;
		} 
		
 	,	showGlassWeightCalculator: function ()
		{ 
			//debugger;
			var view = new ShoppingActionsModuleView({
				application: this.application 
			});		
			view.showContent();	 
		}
	});
});
